import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import Title from '../../common/Title';

import { toPercentTime, toPercentTimeDesc, updateQueryStringParameter } from '../../../../common/utils/convertUtil';

export default function EventBanner(props) {
  const containerClassName = (!props.live_img && !props.pc_pgm_img) ? 'curation_content_w_type4' : (!props.live_img && !props.m_pgm_img) ? 'curation_content_w_type2' : 'curation_content_w_type1';
  const bgColor = !props.pc_bg_color ? 'black' : props.pc_bg_color;
  const thumbnailClassName = 'module_box_w_type1';

  let progressPercent = (props.live_start_time && props.live_end_time) ? toPercentTime(props.live_start_time, props.live_end_time) : null;
  progressPercent = (progressPercent > 100 || progressPercent < 0) ? null : progressPercent;
  const progressDesc = (progressPercent) ? toPercentTimeDesc(props.live_start_time, props.live_end_time, progressPercent) : '';

  const bannerLinkUrl = props.pc_link ? updateQueryStringParameter(props.pc_link, 'div', 'live_list') : null;

  return (
    <>
      {
        props.pc_banner_img && (<>
          {props.formation_title_svc !== 'N' && (<Title title={props.formation_title} />)}
          <div className={containerClassName} style={{ background: bgColor}}>
            <div className='curation_inner'>
              {(!props.live_img && !props.pc_pgm_img) && (
                <div className='curation_img_w'>
                  <Link href={`${bannerLinkUrl}`}>
                    <a target={(props.pc_link_new === 'Y' ? '_blank' : '_self')} className='curation_img_link'>
                      <img className='cr_image'
                        src={props.pc_banner_img}
                        alt={props.pc_banner_img_content}
                      />
                    </a>
                  </Link>
                </div>)}

              {(props.live_img || props.pc_pgm_img) && (<>

                <div className='curation_img_w'>
                  <Link href={bannerLinkUrl}>
                    <a style={{ heigh: '100%' }} target={(props.pc_link_new === 'Y' ? '_blank' : '_self')}>
                      <img className='cr_image'
                        src={props.pc_banner_img}
                        alt={props.pc_banner_img_content}
                      />
                    </a>
                  </Link>
                </div>
                <div className={thumbnailClassName} style={{ height: '216px' }}>
                  <Link href={bannerLinkUrl}>
                    <a style={{ heigh: '100%' }} target={(props.pc_link_new === 'Y' ? '_blank' : '_self')} className='mb_link'>

                      {!props.live_img &&
                        (<div className='mb_layer_notice' style={{ height: '216px' }}>
                          <p className='mbl_notice_text'><strong className='mbl_notice_bold'>LIVE </strong>준비중입니다.</p>
                        </div>)}
                      <div className='mb_image_w'>
                        <div className='mb_image_inner' style={{ height: 0 }}>
                          <img className='mb_image'
                            src={props.live_img || props.pc_pgm_img}
                            alt='채널 대표 이미지'
                          />
                        </div>
                        {progressPercent && (<div className='mb_progress_w'>
                          <i className='hclassNameide' />
                          <span className='mb_progress' style={{ width: `${progressPercent}%` }} title={progressDesc} />
                        </div>)}
                      </div>
                    </a>
                  </Link>
                </div>
              </>
              )}
            </div>
            {(!props.live_img && !props.pc_pgm_img) && (<i className="curation_bg" style={{ backgroundColor: bgColor }}></i>)}
          </div>
        </>)
      }
    </>
  );
}
